/** Ory self-hosted connect guidance (Phase A1). */
export const ORY_SELF_HOSTED_INTRO =
  "Assess a prospect's self-hosted Ory deployment from uploaded configuration (recommended for demos).";

export const ORY_SELF_HOSTED_BODY_GUIDANCE = `Recommended for demos: paste redacted module configs as JSON — one slot per file (Kratos kratos.yml, Hydra hydra.yml). idwiz evaluates policy and OAuth settings without dialing the prospect's network.

Live admin URLs are optional and internal-only today (idwiz collectors run server-side). Loopback URLs such as 127.0.0.1 are blocked for prospect projects because they would assess this host's own Kratos.

Secrets are stripped before storage — we never persist client secrets, DSNs, or signing keys.`;

/** @deprecated Use ORY_SELF_HOSTED_INTRO + ORY_SELF_HOSTED_BODY_GUIDANCE */
export const ORY_SELF_HOSTED_GUIDANCE = `${ORY_SELF_HOSTED_INTRO}\n\n${ORY_SELF_HOSTED_BODY_GUIDANCE}`;
